import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TextInput, View } from 'react-native';
import { styles as textStyles } from 'design-system/Text';
import { rem } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWeb } from '../../../../constants';
import ItemBadgeWrapper from './ItemBadgeWrapper';
const SearchValueItemBadge = ({ index, filter, handleClose, scrollY, cancelEdit, scrollToItem, onSearchValueChange, clearEmptyTextInputFilters, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const ref = useRef(null);
    const inputRef = useRef(null);
    const [inputWidth, setInputWidth] = useState(5 + filter.label.length * 8);
    const isMounted = useRef(false);
    useEffect(() => {
        if (isWeb) {
            if (isMounted.current) {
                setInputWidth(5 + filter.label.length * 8);
            }
            else {
                isMounted.current = true;
            }
        }
    }, [filter.label.length]);
    const handlePress = useCallback(() => {
        inputRef.current?.focus();
    }, []);
    const handleFocus = useCallback(() => {
        cancelEdit();
        ref.current?.measure((_x, _y, _width, _height, pageX) => {
            scrollToItem(pageX);
        });
    }, [cancelEdit, scrollToItem]);
    const onChangeText = useCallback((newText) => {
        onSearchValueChange(newText, index);
    }, [index, onSearchValueChange]);
    return (<View ref={ref}>
      <ItemBadgeWrapper onCancel={handleClose} scrollY={scrollY} handlePress={handlePress} isActiveKeyboard={false} scrollToItem={scrollToItem}>
        <View style={styles.container}>
          <TextInput ref={inputRef} spellCheck={false} autoCorrect={false} autoComplete="off" value={filter.label} pointerEvents="none" onFocus={handleFocus} onChangeText={onChangeText} onBlur={clearEmptyTextInputFilters} selectionColor={colors.text.selection} style={[styles.textInput, isWeb && { width: inputWidth }]}/>
        </View>
      </ItemBadgeWrapper>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: rem(2),
    },
    textInput: {
        ...textStyles.Text_14,
        margin: 0,
        padding: 0,
        lineHeight: undefined,
        color: colors.text.primary,
    },
}));
export default SearchValueItemBadge;
